<template>
  <main class="implants-page">

        <div class="silimed-buttons animate-element" ref="silimedButtons">
      <a href="#" @click="goToHowToSuit">{{ $t('suit.suit')}}</a>
      <a href="#" @click="goToHowToWash">{{ $t('suit.wash')}}</a>
    </div>

    
    <section class="silimed">
      <h2 class="section-title">{{ $t('suit.title')}}</h2>
    
      <div class="silimed-text">
        <h2>{{ $t('suit.attention')}}</h2>
        <p>{{ $t('suit.p')}}</P>
        <P>{{ $t('suit.p1')}}</P>
        <p>{{ $t('suit.p2')}}</p>
        <p>{{ $t('suit.p3')}}</p>
        <p>{{ $t('suit.p4')}}</p>
        <h2>{{ $t('suit.howtoundersrand')}}</h2>
        <p>{{ $t('suit.p5')}}</p>
        <p>{{ $t('suit.p6')}}</p>
        <p>{{ $t('suit.p7')}}</p>
        <p>{{ $t('suit.p8')}}</p>
      </div>
    </section>
  </main>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MainImplants',
  data() {
    return {
      showCurve: true
    }
  },
  
  setup() {
    const router = useRouter()

    function goToHowToSuit() {
      router.push("/howtosuit")
    }
    function goToHowToWash() {
      router.push("/howtowash")
    }

    return { goToHowToSuit , goToHowToWash }
  },

  mounted() {
    this.initAnimations();
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Проверить сразу при монтировании
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    switchLang(lang) {
      this.$i18n.locale = lang
    },
    initAnimations() {
      // Активируем анимацию кривой (только если она видна)
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line');
          if (curveLine) {
            curveLine.classList.add('animate-curve');
          }
        }, 100);
      }
      
      // Функция для проверки видимости элемента
      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        );
      };
      
      // Функция обработки скролла
      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element');
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate');
          }
        });
      };
      
      // Запуск при загрузке и при скролле
      window.addEventListener('load', handleScroll);
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Проверить сразу
    },
    handleResize() {
      this.showCurve = window.innerWidth > 768;
    }
  }
}
</script>


<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.container {
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.silimed {
  text-align: center;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.section-title{
  color: #505050;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 10px;
  margin-bottom: 100px;
}

.silimed-banner{
  display: flex;
  align-items: stretch;
  align-content: stretch;
  justify-content: space-between;
  margin-top: -20px;
  background: #fff;
  margin-top: 50px;
  margin-bottom: 50px;
}

.silimed-banner img {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  margin: auto;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}

.silimed-text {
  max-width: 1160px;
  margin: 0 auto;
  text-align: left;
}

.silimed-text h2 {
  color: #0d1016;
  font-size: 30px;
  font-weight: 100;
  line-height: normal;
  margin-bottom: 25px;
}

.silimed-text p {
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  color: #555;
  font-size: 18px;
}

.grid-5 {
  display: grid;
  row-gap: 50px;
}

.model-red {
  border: 1px solid #f07e23;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  text-align: left;
  padding: 30px 30px 30px 30px;
}

.card-title {
  color: #888;
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 25px;
}

.card-availability p {
  font-size: 16px;
  font-kerning: 300;
  color: #3D3D3D;
  margin-bottom: 20px;
}

.model-blue{
  border: 1px solid #006da2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  text-align: left;
  padding: 30px 30px 30px 30px;
}

.implants-page-end{
  display: grid;
  row-gap: 40px;
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.implants-page-end h2{
  color: #3d3d3d;
  font-size: 13px;
  font-weight: 300;
}

.implants-page-end p{
  color: #3d3d3d;
  font-size: 13px;
  font-weight: 400;
}

.implants-page-end span{
  color: #3d3d3d;
  font-size: 13px;
  font-weight: 400;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}


/* ===== 1440px (ноутбуки) ===== */
@media (max-width: 1440px) {
  .section-title {
    font-size: 32px;
    margin-bottom: 80px;
  }

  .silimed-text h2 {
    font-size: 26px;
  }

  .silimed-text p {
    font-size: 16px;
    line-height: 28px;
  }
}

/* ===== 1024px (планшеты) ===== */
@media (max-width: 1024px) {
  .section-title {
    font-size: 28px;
    margin-bottom: 60px;
  }

  .silimed-banner img {
    height: 150px;
  }

  .silimed-buttons {
    gap: 20px;
  }

  .silimed-buttons a {
    min-width: 180px;
    font-size: 14px;
    line-height: 40px;
  }

  .silimed-text h2 {
    font-size: 24px;
  }

  .silimed-text p {
    font-size: 15px;
    line-height: 26px;
  }
}

/* ===== 768px (малые планшеты / большие телефоны) ===== */
@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
    margin-bottom: 40px;
  }

  .silimed-banner img {
    width: 100%;
    height: auto;
  }

  .silimed-buttons {
    flex-direction: column;
    gap: 15px;
  }

  .silimed-buttons a {
    width: 100%;
    min-width: unset;
    font-size: 14px;
    line-height: 40px;
  }

  .silimed-text h2 {
    font-size: 20px;
  }

  .silimed-text p {
    font-size: 14px;
    line-height: 24px;
  }
}

/* ===== 480px (мобильные) ===== */
@media (max-width: 480px) {
  .section-title {
    font-size: 20px;
    line-height: 28px;
  }

  .silimed-banner img {
    width: 100%;
    height: auto;
  }

  .silimed-buttons {
    gap: 10px;
  }

  .silimed-buttons a {
    font-size: 13px;
    padding: 8px 12px;
    line-height: 36px;
  }

  .silimed-text h2 {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .silimed-text p {
    font-size: 13px;
    line-height: 22px;
  }
}
</style>